import vcfLinks from './vcfLinks';

export default vcfLinks;
